import {
  observable,
  action,
  computed,
  toJS,
} from 'mobx';

import {
  EASY_CUSTOMIZATION_CONFIG,
  DYNAMIC_URL_CONFIG,
  EVENTS_AND_ANALYTICS_CONFIG,
  EVENTS,
} from '~/src/config/galleries';

export default class HomeStore {

  eventsList = EVENTS;
  @observable events = [];
  @observable dynamicUrlTransformations = {
    // default watermark (CLD logo)
    waterMarkAsset: {
      public_id: DYNAMIC_URL_CONFIG.transformation.transformation[2].overlay.public_id
    },
    // default overlay text
    waterMarkText: DYNAMIC_URL_CONFIG.transformation.transformation[1].overlay.text.trim(),
  }
  @observable easyCustomizationConfig = EASY_CUSTOMIZATION_CONFIG;
  @observable dynamicUrlConfig = DYNAMIC_URL_CONFIG;
  @observable eventsAndAnalyticsConfig = EVENTS_AND_ANALYTICS_CONFIG;

  @observable count = 0;

  @observable formState = {};

  @computed get easyCustomizationWidgetParams () {
    const {
      mode,
      columns
    } = this.easyCustomizationConfig.displayProps;
    const {
      active,
      primary
    } = this.easyCustomizationConfig.themeProps;
    const {
      color,
      shape,
      iconColor,
      buttonSize
    } = this.easyCustomizationConfig.navigationButtonProps;

    return {
      carouselLocation: this.easyCustomizationConfig.carouselLocation,
      displayProps: {mode, columns},
      themeProps: {active, primary},
      navigationButtonProps: {
        color,
        shape,
        iconColor,
        buttonSize
      }
    };
  }

  @action
  setEasyCustomizationConfig = (key, value) => {
    // Clone the original config so we don't change that (fixes prevProps/this.props)
    const newConfig = toJS(this.easyCustomizationConfig);
    switch (key) {
      case 'shape':
      case 'iconColor':
        newConfig.navigationButtonProps[key] = value;
        break;
      case 'mode':
      case 'columns':
        newConfig.displayProps[key] = value;
        break;
      default:
        newConfig[key] = value;
        break;
    }
    this.easyCustomizationConfig = newConfig;
  };

  @action
  setEasyCustomizationColors = value => {
    this.easyCustomizationConfig.navigationButtonProps.color = value;
    if (this.easyCustomizationConfig.zoomProps) {
      this.easyCustomizationConfig.zoomProps.lensColor = value;
      this.easyCustomizationConfig.zoomProps.lensBorderColor = value;
    }
    this.easyCustomizationConfig.themeProps.active = value;
    this.easyCustomizationConfig.themeProps.primary = value;
  }

  @computed get dynamicUrlCode () {
    // The url will update inside the component.
    // There might be a better way to generate & update the url, but
    // cloudinaryCore.getImageUrl() returns broken results.
    return 'https://res.cloudinary.com/demo/image/upload/c_fill,dpr_auto,g_auto,h_600,w_600/e_replace_color:7CA9CB:10:7CA9CB/b_black,bo_5px_solid_black,co_rgb:ffffff,g_north_west,l_text:Poppins_60_light:%20-40%25%20,x_0,y_40/g_south_east,l_Product%20gallery%20demo:New%20Demo%20Pages:Tshirt:cld-logo,x_30,y_30/dpr_auto/c_fill/v1/Product%20gallery%20demo/New%20Demo%20Pages/Tshirt/tshirt1';
  }

  @action
  setWaterMarkAsset = asset => {
    let transformation = toJS(this.dynamicUrlConfig.transformation.transformation[2]);
    if (asset) {
      if (!transformation.overlay) {
        transformation = DYNAMIC_URL_CONFIG.transformation.transformation[2];
      }
      transformation.overlay.public_id = asset.public_id;
      this.dynamicUrlTransformations.waterMarkAsset.public_id = asset.public_id;
    }
    else {
      transformation = {};
      this.dynamicUrlTransformations.waterMarkAsset.public_id = null;
    }
    this.dynamicUrlConfig.transformation.transformation[2] = transformation;
  }

  @action
  setWaterMarkText = text => {
    let transformation = toJS(this.dynamicUrlConfig.transformation.transformation[1]);
    if (text) {
      if (!transformation.overlay) {
        transformation = DYNAMIC_URL_CONFIG.transformation.transformation[1];
      }
      transformation.overlay.text = encodeURIComponent(' ' + text + ' ');
    }
    else {
      transformation = {};
    }
    this.dynamicUrlConfig.transformation.transformation[1] = transformation;
  }

  @action
  setProductColor = (color) => {
    let transformation = toJS(this.dynamicUrlConfig.transformation);
    transformation.transformation[0]['effect'] = `replace_color:${color.replace('#', '')}:10:7CA9CB`;
    this.dynamicUrlConfig.thumbnailProps.transformation.transformation[0] = transformation.transformation[0];
    this.dynamicUrlConfig.transformation = transformation;
  }

  @action addEvent = event => {
    this.events.push(event);
    if (this.events.length > 10) {
      this.events.shift();
    }
  }
}
